module.exports = __webpack_public_path__ + "img/drh5_title_sc.7b2b79e8.png";